import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "./no_items.module.scss";

type NoItemsProps = {
  searchTerm: string;
  noOptionsText?: string | ((searchTerm: string) => string);
};

export const NoItems = ({ searchTerm, noOptionsText }: NoItemsProps) => {
  const { t } = useTranslation("core");

  if (noOptionsText) {
    const text = typeof noOptionsText === "function" ? noOptionsText(searchTerm) : noOptionsText;
    return (
      <div className={css.root}>
        <Typography variant="bodyRegular">{text}</Typography>
      </div>
    );
  }

  if (!searchTerm) {
    return null;
  }

  return (
    <div className={css.root}>
      <Icon name="missing" color="paletteBlue2" />
      <Typography variant="bodyRegular">{t("components.select.noItemsToShow")}</Typography>
    </div>
  );
};
